import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Calibration_Interface, Empty_Calibration_Interface } from 'src/app/Interface/Calibration_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CertificateService } from 'src/app/Service/Certificate/Certificate.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-CertifivateDeliveryForm',
  templateUrl: './CertifivateDeliveryForm.component.html',
  styleUrls: ['./CertifivateDeliveryForm.component.scss']
})
export class CertifivateDeliveryFormComponent implements OnInit {

  Token:String=""
  Procssing:boolean=false
  DataList_Calibration:Array<Calibration_Interface>=[]
  Dsc_Form:string=""
  EditRecord:number=0

  constructor(
    private modalService: BsModalService,
    private Certificate_Service:CertificateService,
    private Alerify:AlertifyService,
    private Nav_Service:NavService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');

    

    this.Nav_Service.CheckValidPage(this.Token,14).subscribe(
      data=>{
        
        if(this.route.snapshot.paramMap.get('id')!=undefined){

          this.EditRecord = Number(this.route.snapshot.paramMap.get('id'))
          this.Certificate_Service.GetDeliveryCertificateShowForm(this.Token,this.EditRecord).subscribe(
            data=>{
              this.DataList_Calibration=data['device']
              this.Dsc_Form=data['dsc']
            },error=>{
              localStorage.clear()
              location.reload();
    
            }
          )
        }

      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )

  }

  OnSubmitForm(){
    this.Procssing=true
    this.Certificate_Service.PostDelivery(this.DataList_Calibration,this.Dsc_Form,this.Token).subscribe(
      data=>{
        this.DataList_Calibration=[]
        this.Dsc_Form=""
        this.Procssing=false
        this.Alerify.SuccessMessage("The information was registered successfully")
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }


  //#region Calibration Certificate
  modalRef_Certificate: any;
  Procssing_Certificate:boolean=false
  Search_Code_Certificate_Table:string=""
  Data_Certificate_Search:Array<Calibration_Interface>=[]

  ReadData_Certificate(){
    if(!this.Search_Code_Certificate_Table)
    {
      this.Data_Certificate_Search=[]
    }
    else{
      this.Procssing_Certificate=true
      this.Certificate_Service.GetDeliveryCertificateSearch(this.Token,this.Search_Code_Certificate_Table).subscribe(
        data=>{
          this.Procssing_Certificate=false
          this.Data_Certificate_Search=data
        },error=>{
          this.Data_Certificate_Search=[]
          this.Procssing_Certificate=false
        }
      )
    }
  }

  ReadData_Certificate_KeySearch_Timer:any
  ReadData_Certificate_KeySearch(){

    if (this.ReadData_Certificate_KeySearch_Timer) {
      clearTimeout(this.ReadData_Certificate_KeySearch_Timer);
      this.ReadData_Certificate_KeySearch_Timer = null;
  }

  this.ReadData_Certificate_KeySearch_Timer = setTimeout(function (){
    this.ReadData_Certificate()
  }.bind(this), 1000);

  }

  Set_Selected_Certificate_Record(item)
  {
    console.log(item);
    console.log(item);

    var Check_Record_Data_List_Calibration_Status:boolean=false;
      for(let itemDetail of this.DataList_Calibration)
      {
        if(itemDetail.id==item.id)
        {
          Check_Record_Data_List_Calibration_Status=true
          break;
        }
      }

      if(Check_Record_Data_List_Calibration_Status)
      {
        this.Alerify.ErrorMessage("This calibration certificate has already been selected")
      }
      else{
        this.DataList_Calibration.push(item)
        this.modalRef_Certificate.hide()
        this.Alerify.SuccessMessage("Selected successfully")
      }


  }

  openModal_Certificate(template: TemplateRef<any>) {
    this.modalRef_Certificate = this.modalService.show(template);
  }

  DataList_Calibration_Remove(index)
  {
    this.DataList_Calibration.splice(index,1)
    this.Alerify.SuccessMessage("Deleted successfully")
  }

  //#endregion

}
